import {Injectable} from '@angular/core';
import {GeneralService} from './general.service';
import {HttpClient} from '@angular/common/http';
import {UiSettingsService} from '../../shared/ui-settings.service';
import {Group} from '../interfaces/group';
import { SuperuserServiceModule } from '../superuser-service.module';

@Injectable({
  providedIn: SuperuserServiceModule
})
export class GroupService extends GeneralService<Group> {

  constructor(http: HttpClient, uiSettingService: UiSettingsService) {
    super(http, uiSettingService, 'groups', 'group');
  }
}
